import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingsNavigationComponent } from './settings-navigation/settings-navigation.component';
import { ManageDeviceCategoriesComponent } from './manage-device-categories/manage-device-categories.component';
import { SharedModule } from '../shared/shared.module';
import { StoreModule } from '@ngrx/store';
import { deviceCategoriesReducers } from '../stores/global/device-categories/reducers';
import { EffectsModule } from '@ngrx/effects';
import { DeviceCategoriesEffets } from '../stores/global/device-categories/effects';
import { ManageDeviceManufacturersComponent } from './manage-device-manufacturers/manage-device-manufacturers.component';
import { DeviceManufacturersEffets } from '../stores/global/device-manufacturers/device-manufacturers-effects';
import { deviceManufacturersReducers } from '../stores/global/device-manufacturers/device-manufacturers-reducers';
import { ManageWearingPartsCategoriesComponent } from './manage-wearing-parts-categories/manage-wearing-parts-categories.component';
import { wearingPartCategoriesReducers } from '../stores/global/wearing-part-categories/reducers';
import { WearingPartCategoriesEffets } from '../stores/global/wearing-part-categories/effects';
import { ManageRevisionStatusComponent } from './manage-revision-status/manage-revision-status.component';
import { revisionStatusReducers } from '../stores/global/revision-status/reducers';
import { RevisionStatusEffets } from '../stores/global/revision-status/effects';



@NgModule({
  declarations: [
    SettingsNavigationComponent,
    ManageDeviceCategoriesComponent,
    ManageDeviceManufacturersComponent,
    ManageWearingPartsCategoriesComponent,
    ManageRevisionStatusComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature('deviceCategories', deviceCategoriesReducers),
    StoreModule.forFeature('deviceManufacturers', deviceManufacturersReducers),
    StoreModule.forFeature('wearingPartCategories', wearingPartCategoriesReducers),
    StoreModule.forFeature('revisionStatus', revisionStatusReducers),
    EffectsModule.forFeature([DeviceCategoriesEffets]),
    EffectsModule.forFeature([DeviceManufacturersEffets]),
    EffectsModule.forFeature([WearingPartCategoriesEffets]),
    EffectsModule.forFeature([RevisionStatusEffets])
  ]
})
export class SettingsModule { }
